import React from 'react';
import { SkeletonLoader, LoaderWrapper } from './styles';
export var CardsSkeletonLoader = function (_a) {
    var width = _a.width, itemsCount = _a.itemsCount, extraStyles = _a.extraStyles, cardHeight = _a.cardHeight;
    var loaderCards = [];
    for (var i = 0; i < itemsCount; i++) {
        loaderCards.push(React.createElement(SkeletonLoader, { key: "".concat(i, "_loaderCard"), width: width, cardHeight: cardHeight }));
    }
    return React.createElement(LoaderWrapper, { extraStyles: extraStyles }, loaderCards);
};
